import React from 'react';

import type { ProfileEntry } from '../data/profile';

export type ProfileProps = {
  profile: ProfileEntry;
  hiddenWhenSmall?: boolean;
};

export default function Profile({ profile, hiddenWhenSmall = false }: ProfileProps) {
  const { date } = profile;

  return (
    <div className={`row ${hiddenWhenSmall ? 'hidden-480' : ''}`}>
      <div className="span2 offset1">
        <strong>
          <small>{date}</small>
        </strong>
      </div>
      <div className="span8">
        {profile.type === 'job' ? (
          <>
            {profile.position},&nbsp;<a href={profile.link}>{profile.company}</a>
          </>
        ) : (
          <>
            {profile.degree},&nbsp;<a href={profile.link}>{profile.institution}</a>
          </>
        )}
        <span className="hidden-480">, {profile.location}</span>
      </div>
    </div>
  );
}
